module.exports = __webpack_public_path__ + "static/flapmaxlogo-a3a54019ee599c70f0d37c2f1ecf80e2.jpg";